import {HttpHeaders} from '@angular/common/http';
import {Renderer2} from '@angular/core';

export class FileUtils {
  static downloadFile(input: {data: ArrayBuffer; filename: string; renderer: Renderer2; type: string}): void {
    const blob = new Blob([input.data], {type: input.type});
    const url = window.URL.createObjectURL(blob);

    const link = input.renderer.createElement('a');
    link.href = url;
    link.download = input.filename;
    link.click();

    window.URL.revokeObjectURL(url);
  }

  static stringToBuffer(value: string): ArrayBuffer | null {
    if (!value) {
      return null;
    }
    const buffer = new ArrayBuffer(value.length * 2); // 2 bytes per char
    const view = new Uint16Array(buffer);
    for (let i = 0, length = value.length; i < length; i++) {
      view[`${i}`] = value.charCodeAt(i);
    }
    return buffer;
  }

  static getContentType(headers: HttpHeaders): string {
    const contentType = headers.get('Content-Type');
    if (contentType) {
      return contentType;
    }
    return '';
  }

  static getContentDisposition(headers: HttpHeaders): string {
    const contentDesposition = headers.get('Content-Disposition');
    if (contentDesposition) {
      const splitBySemicolon = contentDesposition.split(';');
      if (splitBySemicolon.length > 1) {
        const splitByEqualTo = splitBySemicolon[1].split('=');
        if (splitByEqualTo.length > 1) {
          return splitByEqualTo[1];
        }
      }
    }
    return '';
  }
}
